import './imports/newsletter-popup'

import 'slick-carousel'

$('.home-slider').on('init', function () {}).slick({
    arrows: false,
    // rows: 0,
    infinite: false,
    autoplay: true,
    speed: 2000,
    pauseOnHover: false,
    autoplaySpeed: 2500,
    fade: true,
    dots: true,
    appendDots: ".home-slider-dots",
}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {});


// WEBPACK FOOTER //
// ./src/js/home.js